import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DecideToolInvocationVariables = Types.Exact<{
  input: Types.DecideToolInvocationInput;
}>;

export type DecideToolInvocation = {
  decideToolInvocation: Pick<
    Types.AIToolInvocation,
    'id' | 'toolName' | 'metadata' | 'approvedAt' | 'rejectedAt' | 'rejectReason' | 'timedOutAt'
  >;
};

export const DecideToolInvocationDocument = gql`
  mutation DecideToolInvocation($input: DecideToolInvocationInput!) {
    decideToolInvocation(input: $input) {
      id
      toolName
      metadata
      approvedAt
      rejectedAt
      rejectReason
      timedOutAt
    }
  }
`;
export type DecideToolInvocationMutationFn = Apollo.MutationFunction<
  DecideToolInvocation,
  DecideToolInvocationVariables
>;

/**
 * __useDecideToolInvocation__
 *
 * To run a mutation, you first call `useDecideToolInvocation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecideToolInvocation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decideToolInvocation, { data, loading, error }] = useDecideToolInvocation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecideToolInvocation(
  baseOptions?: Apollo.MutationHookOptions<DecideToolInvocation, DecideToolInvocationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DecideToolInvocation, DecideToolInvocationVariables>(
    DecideToolInvocationDocument,
    options,
  );
}
export type DecideToolInvocationHookResult = ReturnType<typeof useDecideToolInvocation>;
export type DecideToolInvocationMutationResult = Apollo.MutationResult<DecideToolInvocation>;
export type DecideToolInvocationMutationOptions = Apollo.BaseMutationOptions<
  DecideToolInvocation,
  DecideToolInvocationVariables
>;
export function mockDecideToolInvocation({
  data,
  variables,
  errors,
}: {
  data: DecideToolInvocation;
  variables?: DecideToolInvocationVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: DecideToolInvocationDocument, variables },
    result: { data, errors },
  };
}
